import type { ReactElement } from "react";
import { CatalogManager } from "../catalog/CatalogManager";

export default function ProductCategory(): ReactElement {
  return <CatalogManager kind="category" />;
}
